<template>
    <div class="examRecord">
        <usertop></usertop>
        <div class="user_bread">
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/userindex' }">考试任务</el-breadcrumb-item>
            <el-breadcrumb-item>答案解析</el-breadcrumb-item>
        </el-breadcrumb>
        </div>
        <div class="recordView">
            <div class="recordViewLf lf">
                <div class="recordViewTop" v-for="(item,index) in infoArr">
                    <h1>{{item.title}}</h1>   
                    <label><span>姓名：{{item.nickname}}</span><span>工号：</span></label>        
                    <label><span>试卷总分：{{item.scores}}分</span><span>及格分数：{{item.score}}</span><span>您的得分：{{item.grade}}</span><span>交卷时间：{{item.time}}</span></label>             
                    <img src="/static/img/pass.png" v-if="item.states==1">
                    <img src="/static/img/over.png" v-else-if="item.states==3" >
                    <img src="/static/img/fail.png" v-else >
                </div>
                <div class="recordViewCom">
                    <div class="recordViewtest" v-for="(item,idx) in titleList" :key="idx" >
                        <div class="recordtestlf lf">
                            <h1 v-if="item.q_type!=3">{{idx+1}}.【{{item.q_type | judgeLX }}】{{item.questions}}({{item.scores}}分)</h1>
                            <h1 v-else class="titleh" ref="titletop">{{idx+1}}.【{{item.q_type | judgeLX }}】<span></span>({{item.scores}}分)</h1>
                            <el-checkbox-group v-model="recordexam[idx]" v-if="item.q_type==5 || item.q_type==1 || item.q_type==2" >
                                <el-checkbox  v-for="(a,ix) in item.answer" :key="ix" :label="ix" disabled>{{answerList[ix]}}.{{a}}</el-checkbox>
                            </el-checkbox-group>
                            <el-input
                                type="textarea"
                                :rows="6"
                                placeholder="请输入内容"
                                v-else-if="item.q_type==4"
                                resize='none'
                                show-word-limit
                                v-model="recordexam[idx]"
                                disabled
                                >
                            </el-input>
                            <em v-if="item.results==true">恭喜您，回答正确</em>
                            <em v-else class="faianswer">回答错误
                                <p v-if="item.parsing_answer!=''">知识点：{{item.knowledge}} </p>
                                <p v-if="item.parsing_answer!=''">解析：{{item.parsing_answer}}</p>
                            </em>
                        </div>
                        <div class="recordtestrf rf">
                            <i class="el-icon-check"></i><span>得分：{{item.goal}}分</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="recordViewres rf">
                <h1>答题卡</h1>
                <div class="recordViewresTop">
                    <span class="noexam">未答</span>
                    <span class="passexam">正确</span>
                    <span class="failexam">错误</span>
                </div>
                <div class="recorViewresCom">
                    <div v-for="(item,ix) in subList" :key="ix" class="recorList">
                        <p>{{ix=='radio'&&item.length!=0?'单选题':ix=='judge'&&item.length!=0?'判断题':ix=='fill'&&item.length!=0?'填空题':ix=='qsn'&&item.length!=0?'简答题':ix=='multi'&&item.length!=0?'多选题':''}}</p>
                        <ul>
                            <li v-for="(a,d) in item" v-if="a.result==false" style="background:#F12727">{{a.id}}</li>
                            <li v-else>{{a.id}}</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import usertop from './userTop'
    export default{
        name:'userknow', 
        data(){
            return{
                recordexam:[],
                titleList:[],
                answerList:['A','B','C','D','E','F','G'],
                subList:[],
                id:this.$route.query.id,
                infoArr:[],
            }
        },
        filters:{
            judgeLX:function(value){
                var returnValue="";
                var val = parseInt(value);
                switch(val){
                    case 1:
                        returnValue="单选题";
                        break;
                    case 2:
                        returnValue="判断题";
                        break;
                    case 3:
                        returnValue="填空题";
                        break;
                    case 4:
                        returnValue="简答题";
                        break;
                    case 5:
                        returnValue="多选题";
                        break;
                }
                return returnValue;
            },
       
        },
        components:{
            usertop,
        },
        mounted(){
            var data={
                    service:'Mytask.Parsing',
                    tid:this.id,
                    userid:localStorage.getItem('userid'),
                },
                list=[],
                listIx=[],
                TkList=[],
                infoList=[],
                reg=[],
                sub=[];
            this.$axios.post(this.HOME,this.$qs.stringify(data))
                .then(res=>{
                for(var i=0;i<res.data.data.an.length;i++){
                     if(res.data.data.an[i].q_type==3){
                         reg.push(res.data.data.an[i].questions.replace(/\([^\)]*\)/g,'<input type="text" class="inputtext">'))
                    }
                    list.push(res.data.data.an[i])
                   
                    if(res.data.data.an[i].subanswer==''){
                        res.data.data.an[i].subanswer=-1
                    }
                    listIx.push(res.data.data.an[i].subanswer)
                    console.log(listIx)
                }
                for(let n in res.data.data.info){
                    infoList.push(res.data.data.info[n])
                }
                this.infoArr=infoList
                this.titleList=list
                this.subList=res.data.data.sub
                var NlistIx=listIx.map(Number)
                 for (let key in this.titleList) {
                    if( this.titleList[key].q_type==4){
                        this.$set(this.recordexam, key, listIx[key])
                    }
                    else if(this.titleList[key].q_type==5){
                        this.$set(this.recordexam, key, listIx[key])
                    }
                    else if(this.titleList[key].q_type==1 || this.titleList[key].q_type==2){
                      
                        this.$set(this.recordexam, key,  [NlistIx[key]])
                    }
                    else if( this.titleList[key].q_type==3){
                        
                        for(let i in listIx[key]){
                            if(listIx[key][i]=='null')
                            {
                                TkList.push("")
                                 
                            }
                            else{
                                TkList.push(listIx[key][i])
                            }
                            
                        }
                        console.log(TkList)
                    }   
                }
               this.$nextTick(() => {
                   var list =[]
                   for(let n in $('.titleh')){
                        $('.titleh').eq(n).find('span').html(reg[n])
                    }
                    for(let i in TkList){
                        list.push(TkList[i])
                    }
                    console.log(list)
                   for(var a=0;a< $('.recordViewCom').find('.inputtext').length;a++){
                       if(TkList[a]== -1){
                           TkList[a] =''
                       }
                       $('.recordViewCom').find('.inputtext').eq(a).val(TkList[a])
                       $('.inputtext').eq(a).attr('disabled',true)
                   }
                });
            })
        }
    }
</script>
<style>
    @import "../../assets/css/user.css";
    @import "../../assets/css/task.css";
</style>


// WEBPACK FOOTER //
// src/components/user/userknow.vue